import React, {Component} from "react";
import {Layout} from "antd";

import Sidebar from "../Sidebar/index";
import {footerText} from "util/config";
import App from "routes/index";
import {connect} from "react-redux";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from "../../constants/ThemeSetting";
import { isAuthenticationExcludedUrl } from "../../util/authenticationExcludeUrls";
import { switchLanguage } from "../../appRedux/actions";
import { getStoredLocale } from "../../util/uiPreferences";
import AppLocale from "../../lngProvider";
import { isLivechatApp, isShoperApp } from "../../util/appType";
import PreferencesBootstrap from "../../components/PreferencesBootstrap";
import SendingRestrictedBanner from "../../components/SendingRestrictedBanner";
import SystemStatusBar from "../../components/SystemStatus/SystemStatusBar";

const {Content, Footer} = Layout;

export class MainApp extends Component {

  componentDidMount() {
    if (isShoperApp()) {
      this.props.switchLanguage({locale: "pl"});
      return;
    }
    // Language picked earlier in the account menu (only if that language is still shipped).
    const stored = getStoredLocale();
    if (stored && AppLocale[stored] && stored !== this.props.locale?.locale) {
      this.props.switchLanguage({locale: stored});
    }
  }

  getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default :
        return ""
    }
  };
  getNavStyles = (navStyle) => {
    switch (navStyle) {
      default :
        return null;
    }
  };

  getSidebar = (navStyle, width) => {
    const locale = this.props.locale.locale;
    if (width < TAB_SIZE) {
      return <Sidebar locale={locale}/>;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED :
        return <Sidebar locale={locale}/>;
      case NAV_STYLE_DRAWER :
        return <Sidebar locale={locale}/>;
      case NAV_STYLE_MINI_SIDEBAR :
        return <Sidebar locale={locale}/>;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR :
        return <Sidebar locale={locale}/>;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar locale={locale}/>;
      default :
        return null;
    }
  };

  getAppTypeClass = () => {
    if (isShoperApp()) return "shoper";
    else if (isLivechatApp()) return "livechat";
    else return "";
  }

  render() {
    const {match, width, navStyle} = this.props;
    const isChat = true; // todo red - fix

    return (
      <Layout className={"gx-app-layout " + this.getAppTypeClass()}>
        {!isAuthenticationExcludedUrl() && this.getSidebar(navStyle, width)}
        <Layout>
          {this.getNavStyles(navStyle)}
          <Content className={`gx-layout-content ${ this.getContainerClass(navStyle)} `}>
            {!isShoperApp() && !isAuthenticationExcludedUrl() && <SendingRestrictedBanner/>}
            <App match={match}/>
            {!isShoperApp() && !isAuthenticationExcludedUrl() && <PreferencesBootstrap/>}
            {!isShoperApp() && !isAuthenticationExcludedUrl() && <SystemStatusBar/>}
            {!isChat &&
              <Footer>
                <div className="gx-layout-footer-content">
                  {footerText}
                </div>
              </Footer>
            }
          </Content>
        </Layout>
      </Layout>
    )
  }
}

const mapStateToProps = ({settings}) => {
  const {width, navStyle, locale} = settings;
  return {width, navStyle, locale}
};
export default connect(mapStateToProps, {switchLanguage})(MainApp);

